module.exports = {"510116001":"东升街道","510116002":"西航港街道","510116003":"华阳街道","510116004":"中和街道","510116005":"九江街道","510116006":"黄甲街道","510116017":"怡心街道","510116018":"万安街道","510116019":"正兴街道","510116020":"兴隆街道","510116021":"煎茶街道","510116022":"新兴街道","510116023":"籍田街道","510116024":"太平街道","510116025":"永兴街道","510116108":"彭镇","510116111":"黄龙溪镇","510116112":"永安镇","510116115":"黄水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510116.json
// module id = 2391
// module chunks = 0